<template>
  <v-row>
    <v-col cols="12">
      <v-card outlined class="rounded-card">
        <v-subheader>Links</v-subheader>
        <v-divider/>
        <px-circular-loading v-if="loading"/>
        <v-card-text>
          <div v-if="!loading && !links.length">
            Nenhum link para esse registro
          </div>
        </v-card-text>
        <v-simple-table
          v-if="!loading && links.length"
          fixed-header
        >
          <template v-slot:default>
            <tbody>
            <tr v-for="link in links" :key="link.id">
              <td>
                {{ linkDescription(link) }} #{{ link.id }}
                <px-span-tooltip
                  v-if="link.codigoInterno"
                  bottom
                  text-class="caption"
                  :text="`(${link.codigoInterno})`"
                  tooltip="Código no ERP"/>
              </td>
              <td>
                {{ linkIdentificador(link) }}
              </td>
              <td>
                <px-cotacao-resposta-dialog-view v-if="isCotacao(link)" :cotacao-id="link.id" />
                <px-compra-detalhes-dialog-view v-if="isCompra(link)" :compra-id="link.id" />
                <px-aprovacao-detalhes-dialog-view v-if="isAprovacao(link)"
                                                   :aprovacao-id="link.id" />
                <v-btn icon target="_blank" link :to=linkRedirect(link)>
                  <v-icon>mdi-open-in-new</v-icon>
                </v-btn>
              </td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import RequisicaoService from '@/modules/requisicao/requisicoes-service';

const LINK_DESCRIPTION_MAP = {
  COTACAO: 'Cotação',
  COMPRA: 'Compra',
  APROVACAO: 'Aprovação',
};

const LINK_URL_MAP = {
  COTACAO: link => `/cotacao/${link.id}/respostas`,
  COMPRA: link => `/compra/${link.id}/detalhes`,
  APROVACAO: link => `/aprovacao/${link.id}`,
};

export default {
  props: {
    requisicao: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      links: [],
    };
  },
  computed: {
    isCotacao() {
      return link => link.tipo === 'COTACAO';
    },
    isCompra() {
      return link => link.tipo === 'COMPRA';
    },
    isAprovacao() {
      return link => link.tipo === 'APROVACAO';
    },
    linkDescription() {
      return link => (LINK_DESCRIPTION_MAP[link.tipo] || '');
    },
    linkRedirect() {
      return link => (LINK_URL_MAP[link.tipo](link));
    },
    linkIdentificador() {
      return link => (link.identificador ? link.identificador : '-');
    },
  },
  methods: {
    getLinks() {
      this.loading = true;
      RequisicaoService.getLinks(this.requisicao.id)
        .then(({ data }) => {
          this.links = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.getLinks();
  },
  components: {
    pxCotacaoRespostaDialogView: () => import('@/modules/cotacao/resposta/CotacaoRespostaDialogView.vue'),
    pxCompraDetalhesDialogView: () => import('@/modules/compra/detalhes/CompraDetalhesDialogView.vue'),
    pxAprovacaoDetalhesDialogView: () => import('@/modules/aprovacao/detalhes/AprovacaoDetalhesDialogView.vue'),
  },
};
</script>
